import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
// import { withStyles } from '@mui/material';
import { AppBar } from 'react-admin'
// import BackButton from './backButton'
import { List, RefreshButton,Toolbar, Edit, ListActions, ListButton, TopToolbar, Pagination,  Create, SimpleForm, TextInput, email, BooleanField, Link, Button, SelectInput, Datagrid, TextField, ReferenceField, EditButton, DeleteButton, ShowButton, DateField, useRecordContext, useTranslate } from 'react-admin';
// import { Link } from 'react-router-dom';
import {getLocalStorageKey} from '../common/common'

// const StatusField = ({ record = {}, source }) => (
//     <span>{record[source] === '-' ? '-' : (record[source] ? 'Active' : 'Inactive')}</span>
// )
// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const term_and_conditionsdata=getLocalStorageKey('term_condition_data');
let language_id;
let termConditionId= getLocalStorageKey('term_condition_id')
if(term_and_conditionsdata && term_and_conditionsdata.length>0){
    language_id= term_and_conditionsdata[0].id


}
// const EditActions = ({ permissions, basePath, data, resource }) => (
//     <TopToolbar>
//          <RefreshButton />
//         {/* <ListButton basePath="terms_and_condition_list" /> */}
//         {/* <EditButton basePath={`term_and_conditions/${termConditionId}?language_id=${language_id}`}/> */}
//     </TopToolbar>
// )

const SettingAuditLogButton = () => {
  const record = useRecordContext();
  const translate = useTranslate();
    return (<><Button
      component={Link}
      to={{
        pathname: "/track_trems_logs_history",
        search: `?filter={"id": ${record?.id}}`
      }}
      // to={{
      //   pathname: `/track_trems_logs_history?filter={"id": ${record.id}}`,
      //   // pathname: `/track_trems_logs_history/${record.id}`,
      //   // search: `filter={"id": ${record.id}}`,
      // }}
    >
      <div>
        <p className="view-button">{translate('resources.whitelist_users.fields.view')}</p>
      </div>
      {/* <span className="view-button">View</span> */}
    </Button></>)
  }

  const SettingEditLogButton = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    let term_and_conditionsdatas=getLocalStorageKey('term_condition_data');
    console.log('record', record?.id);
let langId=""
    if(term_and_conditionsdatas && term_and_conditionsdatas.length>0){
     let language = term_and_conditionsdatas.filter(ele=>ele.name===record?.language_name)
     if(language.length>0){
      langId=language[0].id
     }
      return (<><Button
        component={Link}
        to={{
          // pathname: `/track_logs_history?filter={"id": ${record.id}}`,
          pathname: `/term_and_conditions/${langId}/${record?.id}`,
          // search: `filter={"id": ${record.id}}`,
        }}
      >
        <div>
          <p className="view-button">{translate('resources.terms_and_condition_list.fields.edit')}</p>
        </div>
        {/* <span className="view-button">View</span> */}
      </Button></>)

  }


  }

 const TermsConditionsList = props => (
    <Scrollbars className="scroll-container">
        <List title="Terms and Conditions List"   {...props}>
            <Datagrid bulkActionButtons={false}>
            <TextField source="language_name" />
            <TextField source="country" />
            <DateField  source="created_at" showTime />
            {/* <DateField label="updated date" source="updated_at" showTime /> */}
                {/* <TextField source="updateBy" /> */}
                <SettingAuditLogButton source="updated_log" />
                <SettingEditLogButton source="edit" />

            </Datagrid>
        </List>
    </Scrollbars>
//     <List {...props}>
//     <Datagrid   key={props.language_name}>
//         <TextField source="language_name" />
//         <TextField source="country" />

//     </Datagrid>
// </List>
);

// country: "kenya"
// created_at: "2020-06-19T20:57:06.115Z"
// ids: [8]
// language_name: "English"
// terms_and_conditions_description: "<p><strong>test test d</strong></p>"
// updated_at: "2021-04-23T10:46:11.324Z"

export default TermsConditionsList;